import PropTypes from 'prop-types'
import s from './CollapseDetails.module.css'

import React from 'react'

export function CollapseDetails({
  id,
  title,
  children,
  isOpen = true,
  className = '',
}) {
  return (
    <details
      id={id}
      className={`${s.row} ${s.details} ${className}`}
      open={isOpen}
    >
      <summary className={s.summary}>
        <h2 className={s.title}>{title}</h2>
      </summary>
      <div>{children}</div>
    </details>
  )
}

CollapseDetails.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
}
